import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
  defaultDataIdFromObject,
} from "apollo-cache-inmemory";

import introspectionResult from "@hubcapp/graphql/fragments";

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: introspectionResult,
});

const cache = new InMemoryCache({
  fragmentMatcher,
  dataIdFromObject: object => {
    // standardize cache key for events for predictability when fetching from cache
    if (
      object.__typename === "PaidLessonEvent" ||
      object.__typename === "UnpaidLessonEvent" ||
      object.__typename === "NewLessonEvent" ||
      object.__typename === "UnavailableEvent" ||
      object.__typename === "TravelEvent"
    ) {
      return `Event:${object.id}`;
    }

    return defaultDataIdFromObject(object);
  },
  cacheRedirects: {
    Query: {
      event: (_, args, { getCacheKey }) =>
        getCacheKey({ __typename: "Event", id: args.id }),
      region: (_, args, { getCacheKey }) =>
        getCacheKey({ __typename: "Region", id: args.id }),
    },
  },
});

export default cache;
